module.exports = __webpack_public_path__ + "static/facade_home_HDx2-9249ee44cfddf5cb1529b6808e774955.png";